import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogContentText } from "@mui/material"
import React, { useState } from "react";
import { CancelButton } from "../../../../app/components/CancelButton";
import { useAppDispatch } from "../../../../app/hooks";
import { showError, showSuccess } from "../../../notifications/notificationsSlice";
import { CompanyRoleResponsibility, restoreCompanyRoleResponsibility } from "./companyRoleReponsibilitiesApi";
import { RestoreButton } from "../../../../app/components/RestoreButton";

interface RestoreSystemRoleResponsibilityDialogProps {
    roleCode: string;
    onSaveSuccess: (restored: CompanyRoleResponsibility) => void;
    onCancel: () => void;
}

export const RestoreSystemRoleResponsibilityDialog: React.FC<RestoreSystemRoleResponsibilityDialogProps> = ({
    roleCode,
    onSaveSuccess,
    onCancel,
}) => {
    const dispatch = useAppDispatch();

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleConfirm = async () => {
        setSaving(true);
        try {
            const result = await dispatch(
                restoreCompanyRoleResponsibility({ roleCode })
            );
            if (restoreCompanyRoleResponsibility.fulfilled.match(result)) {
                const restored = result.payload as CompanyRoleResponsibility;
                dispatch(showSuccess("saved"));
                onSaveSuccess(restored);
            } else {
                let errorMsg = "error";
                if (result.payload && result.payload.kind === "http") {
                    const problem = result.payload.problem;
                    if (problem) {
                        errorMsg = problem.title;
                    }
                }
                setServerError(errorMsg);
            }
        } catch (error) {
            dispatch(showError("error"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <Localized id="role-responsibility-restore-system">
                        <span>
                           _restore
                        </span>
                    </Localized>
                </DialogContentText>
                {serverError && (
                    <Alert
                        sx={{ marginTop: 1 }}
                        onClose={() => {
                            setServerError("");
                        }}
                        severity="error"
                    >
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <RestoreButton
                    loading={saving}
                    onClick={handleConfirm}
                />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>
    );
};
